import React, {useEffect} from "react";



const gallery = [
  {
    id: 1,
    image: "",
  },
  {
    id: 2,
    image: "",
  },
  {
    id: 3,
    image: "",
  },
];



export default function ConveyorBelt() {

  const [index, setIndex] = React.useState(0);

  const timeoutRef = React.useRef(null);

  function resetTimeout() {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
  }

  useEffect(() => {
    resetTimeout();
    timeoutRef.current = setTimeout(
      () =>
        setIndex((prevIndex) =>
          prevIndex === gallery.length - 1 ? 0 : prevIndex + 1
        ),
    );

    return () => {
      resetTimeout();
    };
  }, [index]);


  return (
    <>
      <div className="slideshow">
        <div
          className="slideshowSlider"
        >
          {gallery.map((image, index) => (
            <img
              className="slide"
              key={index}
              id={image.id}
              alt={`gallery-slide-${image.id}`}
              src={image.image}
            />
          ))}
        </div>
      </div>
      <div className="arrow-controls">
        <div className="control-left">
          <a className="nav-anchor" href={`#${index - 1}`}>
            <img alt="arrow-right" src="" className="left"/>
          </a>
        </div>
        <div className="control-right">
          <a className="nav-anchor" href={`#${index + 1}`}>
            <img alt="arrow-right" src={""} className="right"/>
          </a>
        </div>
      </div>
    </>
  );
}
